import { requestJson } from "../core/http.js";

export class RemoteClassifier {
  constructor(baseUrl, { request = requestJson, online = () => globalThis.navigator?.onLine !== false } = {}) {
    this.baseUrl = baseUrl;
    this.request = request;
    this.online = online;
    this.lastFailure = 0;
  }

  get available() {
    return Boolean(this.baseUrl) && this.online() && Date.now() - this.lastFailure > 60000;
  }

  warmUp() {
    if (!this.baseUrl) return;
    this.request(`${this.baseUrl}/health`, { timeoutMs: 60000 }).catch(() => {});
  }

  async predict(images, source) {
    try {
      const data = await this.request(`${this.baseUrl}/predict`, {
        method: "POST",
        body: { images: images.slice(0, 4), source },
        timeoutMs: 25000
      });
      if (!data?.probabilities || !Array.isArray(data.classes)) throw new Error("Risposta di analisi non valida");
      return data;
    } catch (error) {
      this.lastFailure = Date.now();
      throw error;
    }
  }
}
